import React from 'react';
import QueueAnim from 'rc-queue-anim';
import { Row, Col, Button} from 'antd';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from './utils';

class Partner extends React.PureComponent {
  getBlockChildren = (data) =>
    data.map((item, i) => {
      const children = item.children;
      return (
        <Col key={i.toString()} {...item}>
          <h1 {...children.title}>
            <span>{i + 1}. </span>
            {children.title.children}
          </h1>
          <div {...children.content}>{children.content.children}</div>
        </Col>
      );
    });

  render() {
    const { ...props } = this.props;
    const { dataSource } = props;
    delete props.dataSource;
    delete props.isMobile;
    const listChildren = this.getBlockChildren(dataSource.block.children);
    return (
      <div {...props} {...dataSource.wrapper}>
        <div {...dataSource.page}>
          <div {...dataSource.titleWrapper}>
            {dataSource.titleWrapper.children.map(getChildrenToRender)}
          </div>
          <OverPack {...dataSource.OverPack}>
            <QueueAnim
              type="bottom"
              key="block"
              leaveReverse
              {...dataSource.block}
              component={Row}
            >
              {listChildren}
            </QueueAnim>
          </OverPack>
          <OverPack {...dataSource.OverPack}>
            <QueueAnim
              type="bottom"
              key="block"
              leaveReverse
              {...dataSource.signIn}
              component={Row}
            >
              <Button {...dataSource.signIn.children.btn} type="primary" href={"#/signin"}>免费入驻</Button>
            </QueueAnim>
          </OverPack>
        </div>
      </div>
    );
  }
}

export default Partner;
